define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/NewFromController",
	"csi/xml"
], function(declare,lang,NewFromController,xml) {

	return declare(NewFromController, {
		getFormData: function() {
			// summary: only allow selection of nodes with Write access in this context
			var fd = this.inherited(arguments);
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateShape);
			return fd;
		},

		_canAggregateShape: function(/*Context*/ctx, /*FormData*/fd) {
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
		}
	});
});